import { mapUnitLabel } from '@web/entities/measurement/model/constants/unit.constant'
import { EUnitType } from '@web/entities/measurement/model/enums/unit.enum'
import { EPhysicalType } from '@web/entities/point'
import type { IOption } from '@web/shared/types/options.type.ts'

import { EMeasurementType } from '../enums/measurement-type.enum'

interface ITypeOption {
  option: IOption<EUnitType>
  supported: {
    typeMeasurement: EMeasurementType[]
    physicalQuantityType: EPhysicalType[]
    isVibration?: boolean
  }
}

export const unitTypeOptions: ITypeOption[] = [
  {
    option: {
      value: EUnitType.MS2,
      label: mapUnitLabel[EUnitType.MS2],
      title: `${mapUnitLabel[EUnitType.MS2]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_ACCELERATION],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.MMS,
      label: mapUnitLabel[EUnitType.MMS],
      title: `${mapUnitLabel[EUnitType.MMS]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_VELOCITY],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.MKM,
      label: mapUnitLabel[EUnitType.MKM],
      title: `${mapUnitLabel[EUnitType.MKM]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_DISPLACEMENT],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.G,
      label: mapUnitLabel[EUnitType.G],
      title: `${mapUnitLabel[EUnitType.G]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_ACCELERATION],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.MMS2,
      label: mapUnitLabel[EUnitType.MMS2],
      title: `${mapUnitLabel[EUnitType.MMS2]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_ACCELERATION],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.MS,
      label: mapUnitLabel[EUnitType.MS],
      title: `${mapUnitLabel[EUnitType.MS]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_VELOCITY],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.MM,
      label: mapUnitLabel[EUnitType.MM],
      title: `${mapUnitLabel[EUnitType.MM]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_DISPLACEMENT],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.M,
      label: mapUnitLabel[EUnitType.M],
      title: `${mapUnitLabel[EUnitType.M]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE
      ],
      physicalQuantityType: [EPhysicalType.VIBRO_DISPLACEMENT],
      isVibration: true
    }
  },
  {
    option: {
      value: EUnitType.DEGREES_CELSIUS,
      label: mapUnitLabel[EUnitType.DEGREES_CELSIUS],
      title: `${mapUnitLabel[EUnitType.DEGREES_CELSIUS]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.TEMPERATURE],
      physicalQuantityType: [EPhysicalType.TEMPERATURE]
    }
  },
  {
    option: {
      value: EUnitType.DEGREES_FAHRENHEIT,
      label: mapUnitLabel[EUnitType.DEGREES_FAHRENHEIT],
      title: `${mapUnitLabel[EUnitType.DEGREES_FAHRENHEIT]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.TEMPERATURE],
      physicalQuantityType: [EPhysicalType.TEMPERATURE]
    }
  },
  {
    option: {
      value: EUnitType.DEGREES_KELVIN,
      label: mapUnitLabel[EUnitType.DEGREES_KELVIN],
      title: `${mapUnitLabel[EUnitType.DEGREES_KELVIN]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.TEMPERATURE],
      physicalQuantityType: [EPhysicalType.TEMPERATURE]
    }
  },
  {
    option: {
      value: EUnitType.VOLT,
      label: mapUnitLabel[EUnitType.VOLT],
      title: `${mapUnitLabel[EUnitType.VOLT]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.VOLTAGE]
    }
  },
  {
    option: {
      value: EUnitType.M_VOLT,
      label: mapUnitLabel[EUnitType.M_VOLT],
      title: `${mapUnitLabel[EUnitType.M_VOLT]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.VOLTAGE]
    }
  },
  {
    option: {
      value: EUnitType.U_VOLT,
      label: mapUnitLabel[EUnitType.U_VOLT],
      title: `${mapUnitLabel[EUnitType.U_VOLT]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.VOLTAGE]
    }
  },
  {
    option: {
      value: EUnitType.A,
      label: mapUnitLabel[EUnitType.A],
      title: `${mapUnitLabel[EUnitType.A]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.AMPERAGE]
    }
  },
  {
    option: {
      value: EUnitType.MA,
      label: mapUnitLabel[EUnitType.MA],
      title: `${mapUnitLabel[EUnitType.MA]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.AMPERAGE]
    }
  },
  {
    option: {
      value: EUnitType.MKA,
      label: mapUnitLabel[EUnitType.MKA],
      title: `${mapUnitLabel[EUnitType.MKA]}`
    },
    supported: {
      typeMeasurement: [
        EMeasurementType.SIGNAL,
        EMeasurementType.SPECTER,
        EMeasurementType.COMMON_LEVEL,
        EMeasurementType.OCTAVE,
        EMeasurementType.ENVELOPE_SPECTER,
        EMeasurementType.ENVELOPE_SIGNAL
      ],
      physicalQuantityType: [EPhysicalType.AMPERAGE]
    }
  },
  {
    option: {
      value: EUnitType.HZ,
      label: mapUnitLabel[EUnitType.HZ],
      title: `${mapUnitLabel[EUnitType.HZ]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.RS, EMeasurementType.TSR],
      physicalQuantityType: [EPhysicalType.RPM]
    }
  },
  {
    option: {
      value: EUnitType.D_HZ,
      label: mapUnitLabel[EUnitType.D_HZ],
      title: `${mapUnitLabel[EUnitType.D_HZ]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.RD, EMeasurementType.TSRD],
      physicalQuantityType: [EPhysicalType.RPM]
    }
  },
  {
    option: {
      value: EUnitType.ROTATION_COUNT_IN_MINUTE,
      label: mapUnitLabel[EUnitType.ROTATION_COUNT_IN_MINUTE],
      title: `${mapUnitLabel[EUnitType.ROTATION_COUNT_IN_MINUTE]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.RS, EMeasurementType.TSR],
      physicalQuantityType: [EPhysicalType.RPM]
    }
  },
  {
    option: {
      value: EUnitType.D_ROTATION_COUNT_IN_MINUTE,
      label: mapUnitLabel[EUnitType.D_ROTATION_COUNT_IN_MINUTE],
      title: `${mapUnitLabel[EUnitType.D_ROTATION_COUNT_IN_MINUTE]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.RD, EMeasurementType.TSRD],
      physicalQuantityType: [EPhysicalType.RPM]
    }
  },
  {
    option: {
      value: EUnitType.SECONDS_PER_ROTATION,
      label: mapUnitLabel[EUnitType.SECONDS_PER_ROTATION],
      title: `${mapUnitLabel[EUnitType.SECONDS_PER_ROTATION]}`
    },
    supported: {
      typeMeasurement: [EMeasurementType.TSTM],
      physicalQuantityType: [EPhysicalType.RPM]
    }
  }
]
